import * as React from "react";
import * as utils from "../utils";
import {Col, Label, Row} from "react-bootstrap";
import PercentageLabel from "./PercentageLabel";

export default class EntryRow extends React.Component{

    render(){

        const {entries, client, project, task, onItemClick, totalMinutes} = this.props;

        return <Row onClick={() => {onItemClick(task)}} className="entry hoverable">
            <Col sm={2} className="project">
                <PercentageLabel a={client.minutesTotal} b={client.budgetMinutesTotal} minutes={true} label="Client"/> &nbsp;
                <strong>{client.name}</strong>
                <br />
                <PercentageLabel a={project.minutesTotal} b={project.budgetMinutesTotal} minutes={true} label="Project"/> &nbsp;
                {project.name}
            </Col>

            <Col sm={6}>
                {task && (
                    <div>
                        {task.label && (<span><Label>{task.label}</Label> &nbsp;</span>)}
                        {task.name}<br />
                    </div>
                )}
            </Col>
            <Col sm={1}>
                {entries.length}
            </Col>
            <Col sm={2}>
                {totalMinutes && utils.formatHours(totalMinutes)}
            </Col>
            <Col sm={1}>
                {!!task.minutesTotal && !!task.budgetMinutes && (
                    <PercentageLabel a={task.minutesTotal} b={task.budgetMinutes} minutes={true} label="Task" showPercentage/>
                )}
            </Col>
        </Row>
    }
}

// export default connect()(EntryRow)


// WEBPACK FOOTER //
// ./src/components/EntryByTaskRow.js